import { icons } from "@/public";
import { routes } from "../routes/route";

export const ITEMS_PER_PAGE = 9;

export const THEME = "orange";

export const categoryIconMap: Record<string, string> = {
    "Technology & IT": icons.bot,
    "Business & Operations": icons.operations,
    "Industry Specific": icons.target,
};

export const constantText = {
    BY_AI: "By Aimsintel",
    BY_AI_NEWS: "By Aimsnewsdesk",
    EMAIL: "contactus@aimsb2b.com"

}

//footer constants
export const footerSections = [
    {
        title: "Platform",
        links: [
            // { label: "Technology Solutions", href: "/products" },
            { label: "Comparison Tool", href: "/compare-tools" },
            { label: "Vendor Directory", href: "/vendor-directory" },
            { label: "Resources", href: "/whitepapers" },
        ],
    },
    {
        title: "Content",
        links: [
            { label: "News Feed", href: "/tech-news" },
            { label: "Blog", href: "/blog" },
            { label: "Newsletters", href: "/newsletters" },
            // { label: "Industry Reports", href: "/reports" },
            { label: "Webinars and Videos", href: "/webinar-videos" },
            { label: "Infographics", href: "/infographics" },
        ],
    },
    // {
    //     title: "For Vendors",
    //     links: [
    //         { label: "List Your Software", href: "/list-software" },
    //         { label: "Advertising", href: "/advertising" },
    //         { label: "Partner Program", href: "/partners" },
    //         { label: "Vendor Resources", href: "/vendor-resources" },
    //     ],
    // },
    {
        title: "Support",
        links: [
            // { label: "Help Center", href: "/help" },
            { label: "Contact Us", href: `/${routes.CONTACT}` },
            { label: "Privacy Policy", href: "/privacy-policy" },
            { label: "Terms of Service", href: "/terms-and-conditions" },
        ],
    },
];
export const footerCategories = [
    "CRM Software",
    "HR Tech",
    "Marketing Tools",
    "Analytics",
    "Security",
    "Cloud Services",
    "Project Management",
    "Communication",
    "Finance",
    "AI/ML",
];

export const heroCarouselVideos = [
    {
        label: "AI-powered brand intelligence platform for Global Marketing, Branding & PR Teams",
        image: "https://d1xmlr1hz3uxvo.cloudfront.net/Screenshot_13_11_2025_112531_www_youtube_com_8318fe6541.jpeg",
        video_url: "https://www.youtube.com/watch?v=duv1v8JxfFY"
    }, {
        label: "Oracle AI Agent Studio for Fusion Cloud Applications: Demo",
        image: "https://images.unsplash.com/photo-1662947774668-e2ca450802df?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1228",
        video_url: "https://www.youtube.com/watch?v=Tjj4Rk83iJY"
    }, {
        label: "Top 17 New Technology Trends That Will Define 2026",
        image: "https://d1xmlr1hz3uxvo.cloudfront.net/thumbnailify_com_youtube_thumbnail_Full_HD_2025_11_13_05_57_01_bd26494554.jpg",
        video_url: "https://www.youtube.com/watch?v=Otim2mDjsYM"
    }
]